import pick from 'ramda/src/pick'
import pluck from 'ramda/src/pluck'
import prop from 'ramda/src/prop'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { CREATE_PROJECT_PRODUCT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import changeInput from 'root/src/client/logic/form/actions/changeInput'
import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel'
import wait from 'root/src/shared/util/wait'
import { NO_CAMPAIGN_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import paymentTypes from 'root/src/shared/constants/paymentTypes'

export default (formData, { moduleKey }) => async (dispatch) => {
	const { paymentInfo } = formData
	const paymentInfoMod = paymentInfo
		? paymentInfo
		: {
			paymentType: paymentTypes.brandProduct,
			brandProductId: prop('id', formData.products),
			productType: prop('type', formData.products),
			amount: formData.amount,
		}
	const requestPayload = {
		...pick(['title', 'description', 'assignees', 'campaign', 'games'], formData),
		paymentInfo: paymentInfoMod,
	}
	const { error, body } = await dispatch(apiRequest(CREATE_PROJECT_PRODUCT, requestPayload))
	if (error) {
		if (error.code === 'NotEnoughKeys') {
			throw { error: 'Not enough keys' }
		}
		if (error.code === 'Forbidden') {
			dispatch(displayModal(NO_CAMPAIGN_MODAL_MODULE_ID))
			throw { error: 'Campaign is not active' }
		}

		if (error?.code === 'RequirementsNotSatisfied') {
			const { assigneesNotSatisfying } = error.props
			dispatch(changeInput(moduleKey, ['assignees']))
			const displayNames = pluck('displayName', assigneesNotSatisfying)
			const message = `${displayNames.join(', ')} ${displayNames.length > 1 ? 'were' : 'was'} removed due to requirements of drop.`
			throw { error: message }
		}

		throw error
	}

	mixpanel.track(mixpanelEvents.projectCreated)
	mixpanel.track(mixpanelEvents.dropClaim)
	// this wait is here because projects aren't instantly created/pledged with elasticSearch
	await wait(1000)
	return { error,	body }
}
